import { ProductClientService, VendorInfoModel } from '@/types/productServerApi';
import utilities from '@/shared/utilities.service';
import { ref } from 'vue';

export default function useVendorInfo(vendorId: string) {
    const vendor = ref<VendorInfoModel>();

    const getVendorInfo = async(): Promise<VendorInfoModel | undefined> => {
        const response = await ProductClientService.getVendorInfo(vendorId)
            .then(utilities.unwrapModel);
        vendor.value = response ?? {} as VendorInfoModel;
        return vendor.value;
    };

    return {
        getVendorInfo,
        vendor,
    };
}
